// SuperAdminHome.js
import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from "../UserContext";
import Header from '../Header';
import { useNavigate } from 'react-router-dom';
import { 
  FaUserShield, 
  FaHeadset, 
  FaUsers, 
  FaWallet, 
  FaChevronRight, 
  FaUserPlus,
  FaBox
} from 'react-icons/fa';
import './index.css';
import AnnouncementModal from '../AnnouncementModal';

const SuperAdminHome = () => {
  const { token, user } = useContext(UserContext);
  const navigate = useNavigate();

  const [dashboardData, setDashboardData] = useState({
    totalAdmins: 0,
    totalOperators: 0,
    totalCustomers: 0,
    totalWallet: 0,
  });

  const [loading, setLoading] = useState(true);
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  
    // Check if modal should be shown on component mount
    useEffect(() => {
      // Create a unique key for this user's login session
      console.log(user.operatorId);
      
      const announcementKey = `announcementShown_${user?.operatorId}`;
      
      // Check if we've already shown the announcement for this login session
      const announcementShown = localStorage.getItem(announcementKey);
      
      if (!announcementShown) {
        setShowAnnouncement(true);
        // Mark that we've shown the announcement for this login session
        localStorage.setItem(announcementKey, 'true');
      }
    }, [user]);

  const fetchDashboard = async () => {
    try {
      const res = await fetch('https://sitiplay.com/portal_php/dashboard/superadmin_dashboard.php', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setDashboardData(data);
      setLoading(false);
    } catch (err) {
      // console.error('Failed to fetch dashboard:', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  // Format number with commas
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleCloseAnnouncement = () => {
    setShowAnnouncement(false);
  };

  return (
    <>
      <Header />
      <div className="superadmin-dashboard">
        <div className="app-link alt-purple">
          <h1>Dashboard:</h1>
          <p><span className='app-head'>SITIPLAY App URL</span>: sitiplay.com/sitiplay.apk</p>
          <div></div>
          <p><span className='app-head'>Downloader Code</span>: 4993789; <a href='https://drive.google.com/file/d/1xCxaaB4bmHXHfoyeEN770J4ryjNqpKrz/view?usp=sharing' target='blank'>please refer the video</a></p>
        </div>

        {loading ? ( 
          <div className="dashboard-loading">
            <div className="loader"></div>
            <p>Loading dashboard data...</p>
          </div>
        ) : (
          <>
            <div className="dashboard-cards">
              <div className="card operator-card1" onClick={() => {navigate('/admins')}}>
                <div className="card-icon">
                  <FaUserShield />
                </div>
                <div className="card-content">
                  <h2>{formatNumber(dashboardData.totalAdmins)}</h2>
                  <p>Admins</p>
                </div>
                <div className="card-arrow">
                  <FaChevronRight />
                </div>
              </div>
              
              <div className="card operator-card" onClick={() => {navigate('/operators')}}>
                <div className="card-icon">
                  <FaHeadset />
                </div>
                <div className="card-content">
                  <h2>{formatNumber(dashboardData.totalOperators)}</h2>
                  <p>Operators</p>
                </div>
                <div className="card-arrow">
                  <FaChevronRight />
                </div>
              </div>
              
              <div className="card customer-card" onClick={() => {navigate('/customers')}}>
                <div className="card-icon">
                  <FaUsers />
                </div>
                <div className="card-content">
                  <h2>{formatNumber(dashboardData.totalCustomers)}</h2>
                  <p>Customers</p>
                </div>
                <div className="card-arrow">
                  <FaChevronRight />
                </div>
              </div>
              
              <div className="card wallet-card"> {/* onClick={() => {navigate('/wallet-history')}} */}
                <div className="card-icon">
                  <FaWallet />
                </div>
                <div className="card-content">
                  <h2>₹{formatNumber(dashboardData.totalWallet)}</h2>
                  <p>Total Wallet</p>
                </div>
                <div className="card-arrow">
                  <FaChevronRight />
                </div>
              </div>
            </div>

            <div className="app-link alt-purple">
              <div>
                <a className='anchor' href='https://sitiplay.com/sitiplay.apk' target='blank'>SITIPLAY APP</a>
                <a className='anchor' href='https://drive.google.com/file/d/1xCxaaB4bmHXHfoyeEN770J4ryjNqpKrz/view?usp=sharing' target='blank'>How to install in TV</a>
              </div>
            </div>
                
            <div className='quick-actions'>
              <h3>Quick Actions</h3>
              <div className="action-buttons">
                <button className="action-btn admin-btn" onClick={() => navigate('/add-admin')}>
                  <FaUserPlus />
                  <span>Add Admin</span>
                </button>
                <button className="action-btn operator-btn" onClick={() => navigate('/add-operator')}>
                  <FaUserPlus />
                  <span>Add Operator</span>
                </button>
                <button className="action-btn customer-btn" onClick={() => navigate('/add-customer')}>
                  <FaUserPlus />
                  <span>Add Customer</span>
                </button>
                <button className="action-btn assign-btn" onClick={() => navigate('/assign-plans')}>
                  <FaBox />
                  <span>Assign Packages</span>
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SuperAdminHome;